import { Link } from 'react-router-dom';

import Master from '../Layouts/Master';

const MembershipFailed = () => (
  <Master title='پرداخت حق عضویت'>
    <div className='row my-5'>
      <div className='col-12 col-md-6 offset-md-3'>
        <div className='bg-white rounded shadow-sm p-4 text-center'>
          <i className='fad fa-times-circle text-danger f-90 my-2'></i>
          <h2 className='text-danger f-18 font-weight-bold my-3'>
            پرداخت ناموفق بود
          </h2>
          <p className='text-secondary f-14'>
            در صورت کسر وجه، حداکثر تا ۷۲ ساعت به حساب شما بازمی‌گردد.
          </p>
          <Link
            to='/panel/profile/match-registered'
            className='btn btn-outline-secondary f-14 px-4 mt-3 ml-2'
          >
            بازگشت
          </Link>
        </div>
      </div>
    </div>
  </Master>
);

export default MembershipFailed;
